import getJSONP, { HOST } from "./request";
import { getPlatform, getGameId, getParam } from "../utils";
const PLATFORM = getPlatform();
const loginPageMap = {
  global: `//gabres.${HOST}/platform/login.html?forward=${encodeURIComponent(
    window.location.href
  )}${getGameId() ? "&gameId=" + getGameId() : ""} `,
  gm99: `//passport.gm99.com/?device=${
    window.platform.isPhone() ? "2" : "1"
  }&forward=${encodeURIComponent(window.location.href)}`,
};
const ajaxUrl = {
  loginPage: {
    global: `https://gabres.${HOST}/platform/login.html`,
    gm99: "https://passport.gm99.com/",
    jp: "https://gabres.37games.com/platform/jpLogin.html",
  },
  checkLogin: {
    global: `//gpassport.${HOST}/center/ajax/get_user_json`,
    gm99: "//passport.gm99.com/ajax/get_user_json",
    jp: "//jppassport.37games.com/center/ajax/get_user_json",
  },
  logout: {
    global: `//gpassport.${HOST}/web_login/logout`,
    gm99: "//passport.gm99.com/login/logout2",
    jp: "//jppassport.37games.com/center/ajax/logout",
  },
  decryptUserInfo: {
    global: `//gactivityapi.${HOST}/survey/decryptUserInfo`,
    gm99: `//eventsapi.gm99.com/survey/decryptUserInfo`,
    jp: `//gactivityapi.37games.com/survey/decryptUserInfo`,
  },
  listServer: {
    global: `//gactivityapi.${HOST}/survey/listServer`,
    gm99: `//eventsapi.gm99.com/survey/listServer`,
  },
  listRole: {
    global: `//gactivityapi.${HOST}/survey/listRole`,
    gm99: `//eventsapi.gm99.com/survey/listRole`,
  },
};
export const loginLink = loginPageMap[PLATFORM];

export const checkLogin = function () {
  return getJSONP(ajaxUrl.checkLogin[PLATFORM]);
};
export const logout = function () {
  return getJSONP(ajaxUrl.logout[PLATFORM]);
};

export const getLoginPage = function () {
  return ajaxUrl.loginPage[PLATFORM];
};
// 20250120: 聚合聊天品牌问卷需要解密用户信息补充前端打点
export const decryptUserInfo = function (userInfo) {
  return getJSONP(ajaxUrl.decryptUserInfo[PLATFORM], {
    userInfo,
  });
};

export const getServerList = function (data) {
  return getJSONP(ajaxUrl.listServer[PLATFORM], data);
};

export const getRoleList = function (data) {
  return getJSONP(ajaxUrl.listRole[PLATFORM], data);
};